export interface TelegramWebApp {
  ready(): void
  expand(): void
  close(): void
  initData: string
  BackButton: {
    show(): void
    hide(): void
    onClick(cb: () => void): void
    offClick(cb: () => void): void
  }
  initDataUnsafe: {
    user?: {
      id: number
      first_name: string
      last_name?: string
      username?: string
      language_code?: string
    }
    auth_date: number
    hash: string
  }
  colorScheme: 'light' | 'dark'
  themeParams: {
    bg_color?: string
    text_color?: string
    hint_color?: string
    link_color?: string
    button_color?: string
    button_text_color?: string
    secondary_bg_color?: string
  }
  viewportHeight: number
  viewportStableHeight: number
}

declare global {
  interface Window {
    Telegram: {
      WebApp: TelegramWebApp
    }
  }
}

const DEV_MOCK: TelegramWebApp = {
  ready: () => {},
  expand: () => {},
  close: () => {},
  initData: '',
  BackButton: {
    show: () => {},
    hide: () => {},
    onClick: () => {},
    offClick: () => {},
  },
  initDataUnsafe: {
    user: { id: 1, first_name: 'Dev', language_code: 'ru' },
    auth_date: 0,
    hash: '',
  },
  colorScheme: 'light',
  themeParams: {},
  viewportHeight: 800,
  viewportStableHeight: 800,
}

export function getTelegramWebApp(): TelegramWebApp {
  if (import.meta.env.DEV) return DEV_MOCK
  return window.Telegram.WebApp
}

export function getInitData(): string {
  if (import.meta.env.DEV) return import.meta.env.VITE_DEV_INIT_DATA ?? ''
  return window.Telegram.WebApp.initData
}

export function initApp(): void {
  const tg = getTelegramWebApp()
  tg.ready()
  tg.expand()
}
